module.exports = __webpack_public_path__ + "img/chateau_vecquee_table.d983c86b.jpg";